'use client';

import { ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: ReactNode;
};

export default function ModalPortal({ children }: Props) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return ReactDOM.createPortal(children, document.body);
}
